import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { captureError } from '@/helpers/RUMService/RUMService';
import { SplitFeatureFlags } from '@/store/modules/split/splitFeatureFlags';
import { FLAGSET_PROPERTY_VALUATION } from '@/types';
import {
  SmgSplitSession,
  SplitSupportedEnvironment,
  SplitSupportedPlatform,
  SplitVuexModule,
  getAndStoreFeatureFlags,
  type SplitState,
} from '@smg-real-estate/vue-experiments';
import { Module } from 'vuex';

export const defaultSmgSplitSession: SmgSplitSession = {
  splitSessionKey: '',
  splitTreatmentsWithConfig: {},
};

export const state = (): SplitState => ({
  treatments: {},
  splitSessionKey: '',
  featureFlagsResponses: {},
  isLoadingFeatureFlags: false,
});

export const splitStoreModule: Module<SplitState, any> = {
  ...SplitVuexModule,
  actions: {
    ...SplitVuexModule.actions,
    async updateSplitStoreFromApi() {
      if (Object.keys(SplitFeatureFlags).length === 0) {
        return;
      }

      const platform = isPlatformIs24() ? SplitSupportedPlatform.IS24 : SplitSupportedPlatform.HG;
      const env =
        import.meta.env.VUE_APP_STAGE === 'prod'
          ? SplitSupportedEnvironment.PROD
          : SplitSupportedEnvironment.TEST;
      try {
        await getAndStoreFeatureFlags(this, [FLAGSET_PROPERTY_VALUATION], {
          platform,
          env,
        });
      } catch (error) {
        captureError(error);
      }
    },
  },
};
